import { useGetHirearchyData } from "@dealer-center/ddc-pages-dashboard-fetch";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import { useOutletContext } from "react-router-dom";
import { AccountCardUI } from "./accountsCarUI";
import { Alert } from "@dealer-center/core-components";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import { findAccount } from "./helper";

export const Hierarchy = () => {
  const { data, isLoading, isError, error } = useGetHirearchyData();
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();
  if (isLoading) {
    return (
      <LoadingIndicator
        actionName="Loading Account Hierarchy Data"
        text="Loading Account Hierarchy Data"
      />
    );
  }
  if (isError) {
    return (
      <Alert title="Error getting account info" type="error">
        {error.message}
      </Alert>
    );
  }
  if (!data || !data.data) {
    return (
      <Alert title="Error getting account info" type="error">
        No data found
      </Alert>
    );
  }
  const foundAccountIds = findAccount(accountEntity.id, [], data?.data);
  return (
    <AccountCardUI data={data.data} foundAccountIds={foundAccountIds || []} />
  );
};
